"use client";

import React from "react";

import { HeaderHelpers } from "./types";

export const HeaderContext = React.createContext<HeaderHelpers | null>(null);
